import React from 'react';
import { Table, TableHeader, TableRow, TableHead } from '@/components/ui/table';

export default function CompanyFundsTableHeader() {
  return (
    <div className="sticky top-0 z-30 w-full bg-background border-b shadow-sm">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[140px]">Code</TableHead>
            <TableHead className="w-[40%]">Fund name</TableHead>
            <TableHead className="w-[20%]">Type</TableHead>
            <TableHead className="w-[30%]">Strategy</TableHead>
            <TableHead className="w-[100px] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
      </Table>
    </div>
  );
}
